export const FETCH_GOLF_SCORECARDS_SUMMARY = 'FETCH_GOLF_SCORECARDS_SUMMARY';
export const FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS = 'FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS';
export const FETCH_GOLF_SCORECARDS_SUMMARY_FAIL = 'FETCH_GOLF_SCORECARDS_SUMMARY_FAIL';
export const REMOVE_GOLF_SCORECARD_SUMMARY = 'REMOVE_GOLF_SCORECARD_SUMMARY';
export const FETCH_GOLF_SCORECARD_DETAIL = 'FETCH_GOLF_SCORECARD_DETAIL';
export const FETCH_GOLF_SCORECARD_DETAIL_FETCHING = 'FETCH_GOLF_SCORECARD_DETAIL_FETCHING';
export const FETCH_GOLF_SCORECARD_DETAIL_SUCCESS = 'FETCH_GOLF_SCORECARD_DETAIL_SUCCESS';
export const FETCH_GOLF_SCORECARD_DETAIL_FAIL = 'FETCH_GOLF_SCORECARD_DETAIL_FAIL';
export const FETCH_GOLF_SCORECARD = 'FETCH_GOLF_SCORECARD';
export const FETCH_GOLF_SCORECARD_FETCHING = 'FETCH_GOLF_SCORECARD_FETCHING';
export const FETCH_GOLF_SCORECARD_SUCCESS = 'FETCH_GOLF_SCORECARD_SUCCESS';
export const FETCH_GOLF_SCORECARD_FAIL = 'FETCH_GOLF_SCORECARD_FAIL';
export const UPDATE_GOLF_SCORECARD = 'UPDATE_GOLF_SCORECARD';
export const UPDATE_GOLF_SCORECARD_UPDATING = 'UPDATE_GOLF_SCORECARD_UPDATING';
export const UPDATE_GOLF_SCORECARD_SUCCESS = 'UPDATE_GOLF_SCORECARD_SUCCESS';
export const UPDATE_GOLF_SCORECARD_FAIL = 'UPDATE_GOLF_SCORECARD_FAIL';
export const DELETE_GOLF_SCORECARD = 'DELETE_GOLF_SCORECARD';
export const DELETE_GOLF_SCORECARD_DELETING = 'DELETE_GOLF_SCORECARD_DELETING';
export const DELETE_GOLF_SCORECARD_SUCCESS = 'DELETE_GOLF_SCORECARD_SUCCESS';
export const DELETE_GOLF_SCORECARD_FAIL = 'DELETE_GOLF_SCORECARD_FAIL';
